var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "root",
    staticClass: "user-tool",
    class: [_vm.type === 'compare' ? 'user-tool_compare' : 'user-tool_favorite']
  }, [_c('div', {
    ref: "handler",
    staticClass: "user-tool__icon",
    class: [{
      'user-tool__icon_active': _vm.active && !_vm.loading
    }, {
      'user-tool__loading': _vm.loading
    }],
    on: {
      "click": function ($event) {
        return _vm.handleClickTool();
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "contentHover",
    staticClass: "pt-4 pb-6 user-tool__content",
    class: [{
      'user-tool__content_active': _vm.showHoverPopover
    }]
  }, [_vm._v("\n    " + _vm._s(_vm.content) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }